import { motion } from "framer-motion";
import { Check } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const FORYOU = [
  "You lead, teach, create, or hold space for others at a high level.",
  "You're tired of pushing through.",
  "You know your body is capable of resting, and you're ready to give it the chance.",
];

const reveal = {
  hidden: { opacity: 0, y: 24 },
  show: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE, delay: i * 0.1 } }),
};

export const Offer = ({ onCta }) => {
  return (
    <section data-testid="offer-section">
      {/* This is for you if */}
      <div className="peach-fade py-24 md:py-36">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12">
          <p className="font-script text-peach-deep text-4xl md:text-5xl leading-none mb-6">this is for you if...</p>
          <ul className="grid grid-cols-1 gap-8 max-w-4xl">
            {FORYOU.map((f, i) => (
              <motion.li
                key={i} variants={reveal} custom={i} initial="hidden" whileInView="show"
                viewport={{ once: true, margin: "-40px" }}
                className="flex items-start gap-5"
              >
                <span className="mt-1 flex h-11 w-11 flex-none items-center justify-center rounded-full bg-rose text-cream">
                  <Check size={20} strokeWidth={2.75} />
                </span>
                <span className="font-display font-medium text-2xl md:text-[1.7rem] text-ink leading-snug">{f}</span>
              </motion.li>
            ))}
          </ul>

          <div className="mt-16 flex justify-center">
            <button
              data-testid="offer-cta-button"
              onClick={onCta}
              className="group inline-flex items-center gap-3 bg-ink text-cream text-sm font-semibold uppercase tracking-[0.2em] px-9 py-4 transition-colors duration-300 hover:bg-rose active:scale-[0.98]"
            >
              Yes, I want this
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Offer;
